export enum EargoDeviceType {
  charger = "charger",
  hi_left = "hi_left",
  hi_right = "hi_right",
  system = "system",
}
